/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DeleteVendorModalState {
    isOpen: boolean;

    data: {
        id: number;

        name: string;
    } | null;
}

export interface DeleteVendorModalDispatchParams {
    id: number;

    name: string;
}

const initialState: DeleteVendorModalState = {
    isOpen: false,
    data: null,
};

export const deleteVendorModalSlice = createSlice({
    name: 'delete-vendor-modal',
    initialState,
    reducers: {
        open(state: DeleteVendorModalState, action: PayloadAction<DeleteVendorModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: DeleteVendorModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});
